import { defineStore } from 'pinia';
import { store } from '@/store';
import basicStorage from '@/utils/basicStorage';

export const userStore = defineStore('user', {
  state: () => ({
    menus: null, //菜单信息
    openKeys: [],
    currentTab: '',
    btnPower: null, //按钮权限
    userInfo: {}, //用户信息
    userSetting: {}, //用户设置
    userAvatar: '', // 用户头像地址
    themeColor: '#1677ff',
    defaultThemeColor: '#1677ff',
    topBarBackground: '#ffffff',
    topBarTextColor: '#1677ff',
    menuBackground: '#1677ff',
    menuTextColor: '#ffffff',
    projectFullName: '智安创搭',
    panes: [
      {
        title: '欢迎页',
        path: '/layout/welcome',
        name: 'welcome',
        closable: false,
      },
    ], //标签页数组
    paneActiveKey: 'welcome', //当前选中的标签页
    cacheNamesList: [], //需要缓存的标签页 只保存keepAlive为true的
    layoutMenu: ['sideMenu'], // 菜单布局样式
    collapsed: false, // 菜单折叠  刷新不保存，只用于页面传值
    globalConfig: {},
  }),
  actions: {
    reset() {
      const stateToPersist = {
        menus: null, //菜单信息
        openKeys: [],
        currentTab: '',
        btnPower: null, //按钮权限
        userInfo: {}, //用户信息
        userSetting: {}, //用户设置
        themeColor: '#1677ff',
        defaultThemeColor: '#1677ff',
        topBarBackground: '#ffffff',
        topBarTextColor: '#1677ff',
        menuBackground: '#1677ff',
        menuTextColor: '#ffffff',
        projectFullName: '智安创搭',
        panes: [
          {
            title: '欢迎页',
            path: '/layout/welcome',
            name: 'welcome',
            closable: false,
          },
        ], //标签页数组
        paneActiveKey: 'welcome', //当前选中的标签页
        cacheNamesList: [], //需要缓存的标签页 只保存keepAlive为true的
        layoutMenu: ['sideMenu'], // 菜单布局样式
        collapsed: false, // 菜单折叠  刷新不保存，只用于页面传值
        globalConfig: {},
      };
      // 本地存储sotre
      basicStorage.setItem('extendData', JSON.stringify(stateToPersist));
    },
    persist() {
      // 过滤掉可能导致循环引用的属性
      const stateToPersist = {
        menus: this.menus,
        openKeys: this.openKeys,
        currentTab: this.currentTab,
        btnPower: this.btnPower,
        userInfo: this.userInfo,
        userSetting: this.userSetting,
        themeColor: this.themeColor,
        defaultThemeColor: this.defaultThemeColor,
        topBarBackground: this.topBarBackground,
        topBarTextColor: this.topBarTextColor,
        menuBackground: this.menuBackground,
        menuTextColor: this.menuTextColor,
        projectFullName: this.projectFullName,
        paneActiveKey: this.paneActiveKey,
        cacheNamesList: this.cacheNamesList,
        layoutMenu: this.layoutMenu,
        globalConfig: this.globalConfig,
      };
      // 本地存储sotre
      basicStorage.setItem('extendData', JSON.stringify(stateToPersist));
    },
    load() {
      // 本地提取store
      const savedState = basicStorage.getItem('extendData');
      if (savedState) {
        const parsedState = JSON.parse(savedState);
        // 过滤掉可能导致循环引用的属性
        const filteredState = {
          menus: parsedState.menus,
          openKeys: parsedState.openKeys,
          currentTab: parsedState.currentTab,
          btnPower: parsedState.btnPower,
          userInfo: parsedState.userInfo,
          userSetting: parsedState.userSetting,
          themeColor: parsedState.themeColor,
          defaultThemeColor: parsedState.defaultThemeColor,
          topBarBackground: this.topBarBackground,
          topBarTextColor: this.topBarTextColor,
          menuBackground: this.menuBackground,
          menuTextColor: this.menuTextColor,
          projectFullName: parsedState.projectFullName,
          paneActiveKey: parsedState.paneActiveKey,
          cacheNamesList: parsedState.cacheNamesList,
          layoutMenu: parsedState.layoutMenu,
          globalConfig: parsedState.globalConfig,
        };
        Object.assign(this, filteredState);
      }
    },
  },
});
// // 在组件setup函数外使用
export function userStoreWithOut() {
  return userStore(store);
}
